import { render, staticRenderFns } from "./zhu.vue?vue&type=template&id=024148bc&scoped=true&"
import script from "./zhu.vue?vue&type=script&lang=js&"
export * from "./zhu.vue?vue&type=script&lang=js&"
import style0 from "./zhu.vue?vue&type=style&index=0&id=024148bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024148bc",
  null
  
)

export default component.exports